import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router';

import { useIsMobileViewport } from './useIsMobileViewport';
import { useSidebarShellStore } from '../store/sidebarShell';

export interface UseAppSidebarStateResult {
  isMobile: boolean;
  shouldShowExpanded: boolean;
  onToggleOpen: () => void;
}

export function useAppSidebarState(): UseAppSidebarStateResult {
  const isMobile = useIsMobileViewport();
  const isOpen = useSidebarShellStore((state) => state.isOpen);

  const onToggleOpen = useCallback(() => {
    useSidebarShellStore.getState().toggle();
  }, []);

  useEffect(() => {
    if (isMobile) {
      useSidebarShellStore.getState().setOpen(false);
    }
  }, [isMobile]);

  const location = useLocation();

  useEffect(() => {
    if (isMobile) {
      useSidebarShellStore.getState().setOpen(false);
    }
  }, [location.pathname, isMobile]);

  return {
    isMobile,
    shouldShowExpanded: isOpen,
    onToggleOpen,
  };
}
